// Page-level "My Shops" bar (My Shop / Provider My Shop): which shop is being
// managed + "Create New Shop". Rendered only for accounts that may own shops
// of this workspace type.
import React from "react";
import { elakayAutoText as text } from "../pageInside/dataElakay";
import { useAccountShops } from "./accountShopsStore";
import ShopSwitcher from "./ShopSwitcher";
import "./shops.css";

const ShopBar = ({ type = "seller", className = "" }) => {
  const { data } = useAccountShops();
  if (!data || !(data.types || []).includes(type)) return null;
  return (
    <div className={`msh-bar ${className}`} data-testid={`shop-bar-${type}`}>
      <span className="msh-bar-label">{text("h_msh_managing", "Shop you are managing")}</span>
      <ShopSwitcher type={type} />
    </div>
  );
};

export default ShopBar;
